const headRowsManagementBackups = {
  file: 'File',
  createdAt: 'Date',
  createdBy: 'Author',
  size: 'Size',
  type: 'Type',
  ingested: 'Ingested',
  download: 'Download',
  edit: 'Edit'
};

export default headRowsManagementBackups;
